export default __webpack_public_path__ + "static/ibis-budget-0b39a92caaed30c74e60c8aa18bee8af.png";